import axios from 'axios';
import { REACT_APP_STRATEGY_ENGINE_URL } from '../apiurl';

// Strategy Engine URL — managed in apiurl.js alongside the main API URL
// (REACT_APP_STRATEGY_ENGINE_URL), so prod/dev are switched in one place.
export const STRATEGY_ENGINE_URL = REACT_APP_STRATEGY_ENGINE_URL;

const strategyApi = axios.create({
    baseURL: STRATEGY_ENGINE_URL,
    timeout: 30000,
    withCredentials: true,
});

// Request interceptor
strategyApi.interceptors.request.use(
    (config) => {
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }
        return config;
    },
    (error) => {
        console.error('Request Error:', error);
        return Promise.reject(error);
    }
);

// Response interceptor
strategyApi.interceptors.response.use(
    (response) => response.data,
    (error) => {
        console.error('Strategy API Error:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
            url: error.config?.url,
        });

        const formattedError = {
            message: error.response?.data?.error?.message || error.response?.data?.message || error.message || 'An error occurred',
            status: error.response?.status,
            data: error.response?.data,
        };

        // 401 means the user doesn't have a Strategy Engine session yet.
        // Return empty data so the page shows its natural empty state
        // ("No strategies yet") instead of a confusing error banner.
        if (error.response?.status === 401) {
            return { success: true, data: [], meta: { page: 1, limit: 10, total: 0 } };
        }

        if (error.response?.status === 403) {
            formattedError.message = 'You don\'t have permission to access this resource.';
        }

        if (error.code === 'ECONNABORTED') {
            formattedError.message = 'Request timeout. Please try again.';
        }

        return Promise.reject(formattedError);
    }
);

export default strategyApi;
